import React from "react";
import { useTranslation } from "react-i18next";
import { PageHero } from "../components/PageHero";
import { PartnerForm } from "../components/PartnerForm";
import { Reveal } from "../components/Reveal";

export default function Partners() {
  const { t } = useTranslation();
  const targets = t("partners.targets", { returnObjects: true });
  return (
    <>
      <PageHero
        overline={t("partners.overline")}
        title={<>{t("partners.titleA")} <span className="text-gradient-gold">{t("partners.titleAccent")}</span></>}
        subtitle={t("partners.subtitle")}
        accent="gold"
        testId="partners-hero"
      />

      <section className="py-16 md:py-20">
        <div className="container-x grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <Reveal>
              <h2 className="font-display font-bold text-2xl sm:text-3xl tracking-tight">{t("partners.whoTitle")}</h2>
              <div className="mt-6 flex flex-wrap gap-2">
                {targets.map((tg) => (
                  <span key={tg} className="px-3 py-2 rounded-md bg-navy-800 border border-white/10 text-sm text-white/70" data-testid={`partner-target-${tg}`}>{tg}</span>
                ))}
              </div>
              <p className="mt-8 text-sm text-white/55 leading-relaxed">{t("partners.whoDesc")}</p>
            </Reveal>
          </div>
          <div className="lg:col-span-7">
            <Reveal delay={0.1}><PartnerForm /></Reveal>
          </div>
        </div>
      </section>
    </>
  );
}
